var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoPasskey = function SvgLogoPasskey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo passkey",
    viewBox: "0 0 24 24",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 6,
    r: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.5a3.5 3.5.0 10-5 3.15V19L19 20.5 21.5 18 20 16.5 21.5 15l-1.24-1.24A3.5 3.5.0 0022.5 10.5zm-3.5.0a1 1 0 111-1 1 1 0 01-1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.44 12.52A6 6 0 0012 12H9a6 6 0 00-6 6v2H16V14.49a5.16 5.16.0 01-1.56-1.97z"
  })));
};
export default SvgLogoPasskey;